import ContentLoader from 'react-content-loader'
import { useTheme } from 'styled-components'

export const MyPositionsContentLoader = () => {
  const theme = useTheme()

  return (
    <ContentLoader
      speed={2}
      width="100%"
      height={360}
      backgroundColor={theme.colors.contentLoader.backgroundColor}
      foregroundColor={theme.colors.contentLoader.foregroundColor}
      style={{ marginTop: 16 }}
    >
      {Array.from({ length: 5 }).map((_, rowIndex) => (
        <rect key={rowIndex} x="0" y={rowIndex * (56 + 16)} rx="5" ry="5" width="100%" height="56" />
      ))}
    </ContentLoader>
  )
}

export const TableValueContentLoader = () => {
  const theme = useTheme()

  return (
    <ContentLoader
      speed={2}
      width={50}
      height={15}
      viewBox="0 0 50 15"
      backgroundColor={theme.colors.contentLoader.backgroundColor}
      foregroundColor={theme.colors.contentLoader.foregroundColor}
    >
      <rect x="0" y="0" rx="3" ry="3" width="50" height="15" />
    </ContentLoader>
  )
}
